module.exports = __webpack_public_path__ + "img/o2o10.d13f8c34.png";